import React from "react";
import "./notice-banner.css";

import Marquee from "react-fast-marquee";

function NoticeBannerMainCampus() {
  return (
    <div className="notice-banner">
      <Marquee gradient={false} speed={80}>
        <label className="notice-label">
          <b>
            Admissions for Grade 1 till Grade 9 (academic year 2026 - 2027) are
            closed for now. Registrations may open in January 2026 in case of
            vacancies
          </b>
        </label>
      </Marquee>
    </div>
  );
}

export default NoticeBannerMainCampus;
